// Footer.js
import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer d-none">
      <style>
        {`
          .footer {
            background-color: #f8f9fa;
            
            text-align: center;
            border-top: 1px solid #dee2e6;
            position: fixed;
            width: 100%;
            bottom: 0;
            left:300px;
            height: 45px;
          }
          .footerContent {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .navLink {
            margin: 0 0.5rem;
            color: #007bff;
            text-decoration: none;
          }
          .navLink:hover {
            text-decoration: underline;
          }
        `}
      </style>
      <div className="container">
        <div className="footerContent">
          <p>{t('footerText')} </p>
         
        </div>
      </div>
    </footer>
  );
};

export default Footer;
